import { useState } from 'react';
import { filterFormItemLayout, filterFormGridLayout, filterFormItemStyle } from '@utils/property';
import { Form, Row, Col, Input, DatePicker, Button, Space, Select, Card, theme } from 'antd';
const { RangePicker } = DatePicker;

export default function UserGroupsFilterForm({ handleFilterFinish, createdPhone }) {
    const { token } = theme.useToken();
    const [form] = Form.useForm();

    const [timePicker, setTimePicker] = useState([]);
    const handleChangeTime = (value, dateString) => {
        setTimePicker(dateString);
    };

    const onFinish = values => {
        values.createdBeginAt = timePicker[0];
        values.createdEndAt = timePicker[1];
        handleFilterFinish(values);
    };

    const onReset = () => {
        form.resetFields();
        const values = {
            name: undefined,
            createStaffPhone: undefined,
            timePicker: undefined,
            createdAtBegin: undefined,
            createdAtEnd: undefined,
            status: undefined,
        };
        handleFilterFinish(values);
    };
    return (
        <Card
            size="small"
            className="user-groups-filter-panel"
            style={{
                marginBottom: token.marginLG,
                border: `1px solid ${token.colorBorderSecondary}`,
                background: token.colorFillAlter,
            }}
        >
            <Form {...filterFormItemLayout} onFinish={onFinish} form={form} autoComplete="off" requiredMark={false}>
                <Row gutter={[16, 16]}>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="关键字" name="name" style={filterFormItemStyle}>
                            <Input allowClear placeholder="用户分群名称关键字" autoComplete="off" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="创建人" name="createStaffPhone" style={filterFormItemStyle}>
                            <Select allowClear placeholder="请选择创建人">
                                {createdPhone
                                    && createdPhone.map(item => {
                                        return (
                                            <Select.Option key={item.phone} value={item.phone}>
                                                {item.name}
                                            </Select.Option>
                                        );
                                    })}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="状态" name="status" style={filterFormItemStyle}>
                            <Select allowClear placeholder="请选择状态">
                                <Select.Option value={0}>禁用</Select.Option>
                                <Select.Option value={1}>启用</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="创建时间" name="timePicker" style={filterFormItemStyle}>
                            <RangePicker allowClear onChange={handleChangeTime} showTime />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label={<span>&nbsp;</span>} colon={false} style={filterFormItemStyle}>
                            <Space size="small">
                                <Button type="primary" htmlType="submit" icon={<i className="bi bi-search" aria-hidden="true" />}>
                                    搜索
                                </Button>
                                <Button type="default" onClick={onReset}>
                                    重置
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
}
